// extracted by mini-css-extract-plugin
export default {"blank":"Blank_blank__PhgAV","title":"Blank_title__tT51Z"};